import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  constructor(private router:Router) {
    var token =localStorage.getItem('token');
    if(token==undefined || token==='' ){
      this.router.navigate(['/login']);
    }
   }

  ngOnInit() {
    var token =localStorage.getItem('token');
    if(token==undefined || token==='' ){
      this.router.navigate(['/login']);
    }
  }
  uploadMaster(){
    this.router.navigate(['/uploadMaster']);
  }
  viewMasterData(){
    this.router.navigate(['/viewMaster']);
  }
  notification(){
    this.router.navigate(['/notification']);
  }
  userPositions(){
    //this.router.navigate(['/userPosition']);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts